import NumberInput from './number-input';

export default NumberInput;
